import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
} from "shared/provider-webworker";
import { IOpsIntPromiseLookupService } from "../IOpsIntPromiseLookupService";
import { ReplicaLookupService } from "../../impl/ReplicaLookupService";
import { ReplicaBlotterLookupService } from "../../impl/ReplicaBlotterLookupService";
import { OpsIntLookupService } from "./OpsIntLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class OpsIntReplicaLookupService
  extends ReplicaBlotterLookupService<string, CubiqTS.OpsIntEventImpl>
  implements IOpsIntPromiseLookupService
{
  constructor(protected factory: ClientMessageBrokerFactory, protected base: OpsIntLookupService) {
    super(factory, CubiqTS.OpsIntEventImpl, "OpsIntEventImpl", CubiqTS.OpsIntEventImpl, true);
  }

  public getFilterCategoryTypes(): Promise<Map<string, CubiqTS.OpsFiltCategoryType>> {
    return new Promise<Map<string, CubiqTS.OpsFiltCategoryType>>((res, rej) => {
      res(this.base.getCategoryTypes());
    });
  }
}
